import { createFileRoute } from '@tanstack/react-router';
import { getTitleContextSlice } from '@utils/breadcrumbsUtils';
import { CodeOwner } from '@utils/router.utils';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/vulnerabilities/settings/exceptions/exceptions-settings')({
  beforeLoad: () => getTitleContextSlice('Exceptions Settings'),
  staticData: {
    owner: CodeOwner.Uvm,
  },
});
